import { ApplianceContent } from '../../models/appliance-content.interface';

const accordionPanels = [
  {
    body: `<p><span style="color:rgb(0,0,0);">Your manufacturer warranty covers you for breakdowns for 12 months only.</span></p>`,
    title: 'Breakdown coverage',
    icon: { name: 'check' },
  },
  {
    body: `<p><span style="color:rgb(0,0,0);">Snaps? Breaks? Accidents happen. When they do, you're not protected by your manufacturer's warranty. We'll cover them - and more.</span></p>`,
    title: 'Immediate Protection For Damage Caused by Accidents',
    icon: { name: 'check' },
  },
  {
    body: `<p><span style="color:rgb(0,0,0);">Broken refrigerator shelves? Wobbly stove knobs? Accessories that came with your original appliance are covered too.</span></p>`,
    title:
      'Coverage For Accessories – such as broken control knobs and door seals',
    icon: { name: 'check' },
  },
  {
    body: `<p><span style="color:rgb(0,0,0);">If you need a repair, just get in touch. It's fast and hassle-free, with no deductibles or unexpected charges.</span></p>`,
    title: 'Unlimited Repairs with No Hidden Costs​ or Deductibles',
    icon: { name: 'check' },
  },
  {
    body: `<p><span style="color:rgb(0,0,0);">If we can't repair your product, we'll replace it with a new one.</span></p>`,
    title: "Brand New Replacement if it can't be fixed",
    icon: { name: 'check' },
  },
];

export const washerApplianceContent: ApplianceContent = {
  title:
    "Your manufacturer's warranty doesn't cover everything - protect your washer today",
  subtitle:
    '<strong>Don’t risk</strong> a $480* repair bill! <strong>Add {{ brandName }} Appliance Care</strong> to protect your washer from damage caused by overloaded drums, broken doors, jammed drawers and detergent disasters.',
  caption:
    '<strong>Plus get cover</strong> for parts you didn’t expect to break, like control knobs, door seals and pumps.',
  accordion: accordionPanels,

  footerDisclaimer:
    '*Estimates only. Based on the 2023 average out-of-warranty parts and labor costs collected from Whirlpool Factory Authorized Service Companies. Excludes refrigeration sealed systems repairs. Actual costs will vary based on location, diagnostic fees, component pricing, installation, and other factors.',
};
